import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { queryParams } from "src/helpers/UrlHelpers";

import PageLayout from '../_partials/PageLayout';
import PageHeader from "./_partials/_PageHeader";

import Account from "./_partials/_Account";
import Leaderboard from "./_partials/_Leaderboard";
import WebhookDeliveries from "./_partials/_WebhookDeliveries";
import './style.scss';

export interface PropsInterface {
  appId: 1 | 2;
}

// Account-level view of the crafty-servers hosting integration: quota,
// the cross-server player leaderboard and the webhook delivery journal.
// Per-server operations stay on each server's own page — this is the
// third facet of the Servers group, next to Listings and Plans.
// Sections switch on the `tab` query param, driven by the header's
// NavBarTwo (the Community pages' pattern).
const Hosting = (_props: PropsInterface) => {
  const [searchParams] = useSearchParams();
  const tab = queryParams.get(searchParams, 'tab');

  return (
    <PageLayout className='v-hosting'>
      <PageHeader />

      <div className='v-container'>
        {tab === 'leaderboard' && <Leaderboard />}
        {tab === 'deliveries' && <WebhookDeliveries />}
        {tab !== 'leaderboard' && tab !== 'deliveries' && <Account />}
      </div>
    </PageLayout>
  );
}

export default Hosting;
